import { BAOCustomElement } from '@bao/custom-element'

class PersonalisationDetails extends BAOCustomElement() {
  static get requiredElements () {
    return ['trigger', 'content']
  }

  connectedCallback () {
    super.connectedCallback()

    const isExpanded =
      this.els.trigger.element.getAttribute('aria-expanded') === 'true'

    this.setExpanded(isExpanded)
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.toggle.bind(this),
    )
  }

  toggle () {
    const isExpanded =
      this.els.trigger.element.getAttribute('aria-expanded') === 'true'

    this.setExpanded(!isExpanded)
  }

  setExpanded (isExpanded) {
    this.els.trigger.element.setAttribute(
      'aria-expanded',
      isExpanded.toString(),
    )

    this.els.content.element.setAttribute(
      'aria-hidden',
      (!isExpanded).toString(),
    )

    if (this.els['more-label']?.element) {
      this.els['more-label'].element.hidden = isExpanded
    }

    if (this.els['less-label']?.element) {
      this.els['less-label'].element.hidden = !isExpanded
    }
  }
}

if (!customElements.get('personalisation-details')) {
  customElements.define('personalisation-details', PersonalisationDetails)
}
